module.exports = __webpack_public_path__ + "img/interface_harvest.d8c1dc81.png";